import React from 'react';
import virm from '../../animated dp2-05.png'
import franz from '../../animated dp2-06.png'
import rachel from '../../animated dp2-07.png'
import nico from '../../animated dp2-08.png'
import ragine from '../../animated dp2-04.png'
import virra from '../../animated dp2-03.png'
import group from '../../rtds team2-01.png'
import found from '../../FOUNDING-03.jpg'
import grow from '../../Growing-03.png'
import fruit from '../../fruits-03.png'

class AboutPage extends React.Component {
    render() {
        return(
            <div className=""> 

                <div className='about'>
                    {/* <div className="about-content">
                        <h3>About Us</h3>
                        <p>
                        Redtomato Design Studio is an innovative and creative studio, aiming to spice up every ideas you can think of.
                        </p>
                    </div> */}
                    <div>
                        <img src={group} alt='about-cover' className='about-cover-img'/>
                    </div>
                    <div className="flex-container ">
                        <div className='about-content'>
                            <h3>About Us</h3>
                            <p>
                            An innovative and creative studio, aiming to spice up every ideas you can think of.
                            </p><br/>
                            {/* <h3>Why Choose RTDS?</h3> */}
                            <p>
                            Redtomato Design Studio will bring your idea to life! We are committed to execute every idea you have through quality designs and outputs for you to show it to the world. Through our passion in creativity and technology we will spice up your idea to make it into a reality. Share your ideas and together we will create an innovative experience.
                            </p><br/>
                        </div>
                    </div>
                    <br/>
                    <div className="flex-container about-content">
                        <div className="flex-container">
                            <div className="flex-item">
                                <img src={found} alt="found" className='about-found-img'/>    
                            </div>
                            <div className="flex-item about-found">
                                <h4>Seeds</h4>
                                <div className="about-found-txt">Redtomato Design Studio was founded by Franz Villamin in 2018. It started as giving services such as branding and illustrating to other startup companies with its designer Ragine Tumulak who also gave the name of the company.  </div>   
                            </div>
                        </div>
                    </div>
                    <div style={{paddingTop:'30px'}} className="about-content">
                        <div className="flex-container-r">
                            <div className="flex-item about-found">
                                <h4>Early Growth</h4>
                                <div className="about-found-txt">After series of branding, we as technologists expanded the company through providing another service that would help companies - Web and Mobile Applications. The power of innovation assisted to spicing every idea one can have.</div>   
                            </div>
                            <div className="flex-item">
                                <img src={grow} alt="grow" className='about-found-img'/>    
                            </div>
                        </div>
                    </div>
                    <div style={{paddingTop:'30px'}} className="flex-container about-content">
                        <div className="flex-container">
                            <div className="flex-item">
                                <img src={fruit} alt="fruit" className='about-found-img'/>    
                            </div>
                            <div className="flex-item about-found">
                                <h4>Fruit</h4>
                                <div className="about-found-txt">We want to spice up the world by being your secret ingredient into baking creative ideas 
                        to life through our quality designs and services that will cater to your needs while 
                        at the same time for us to grow and improve our skills to match the ever fast-paced 
                        and dynamic modern world and technology.</div>   
                            </div>
                        </div>
                    </div>
                    <div style={{paddingTop:'100px'}} className="about-content">
                        <h3>People Behind</h3>
                    </div>
                    <div className="flex-container about-content">
                        <div className='flex-item people'>
                            <img src={franz} alt='franz' className='about-cover-img'/>
                            <p><b>Franz</b></p>
                            <p style={{fontSize:'12px'}}>Chief Executive Officer</p><br/>
                        </div>
                        <div className='flex-item people'>
                            <img src={virm} alt='virm' className='about-cover-img'/>
                            <p><b>Virm</b></p>
                            <p style={{fontSize:'12px'}}>Chief Technology Officer</p><br/>
                        </div>
                        <div className='flex-item people'>
                            <img src={rachel} alt='rachel' className='about-cover-img'/>
                            <p><b>Moniqa</b></p>
                            <p style={{fontSize:'12px'}}>Chief Information Officer</p><br/>
                        </div>
                        <div className='flex-item people'>
                            <img src={ragine} alt='ragine' className='about-cover-img'/>
                            <p><b>Ragine</b></p>
                            <p style={{fontSize:'12px'}}>Chief Design Officer</p><br/>
                        </div>
                        <div className='flex-item people'>
                            <img src={virra} alt='virra' className='about-cover-img'/>
                            <p><b>Vr</b></p>
                            <p style={{fontSize:'12px'}}>Project Manager</p><br/>
                        </div>
                        <div className='flex-item people'>
                            <img src={nico} alt='nico' className='about-cover-img'/>
                            <p><b>Nico</b></p>
                            <p style={{fontSize:'12px'}}>Software Engineer</p><br/>
                        </div>
                    </div>
                </div>


                {/* <h2 className="about-header">Mission</h2>
                <div className="page-content">
                    <p>As company, we are committed to execute ideas through quality designs and outputs that 
                        will cater and satisfy the client’s needs.
                        As a team, we are committed to support each other to maximize our strengths and to improve
                         on our weaknesses, at the same time, contribute our specialties to the benefit of the projects,
                          as well as, the growth of the company and the team itself.</p>
                </div>
                <h2 className="about-header">Vision</h2>
                <div className="page-content">
                    <p>We want spice up the world by being your secret ingredient into baking creative ideas 
                        to life through our quality designs and services that will cater to your needs while 
                        at the same time for us to grow and improve our skills to match the ever fast-paced 
                        and dynamic modern world and technology.</p>
                </div>
                <h2 className="about-header">Background</h2>
                <div className="page-content">
                    <p>
                    Redtomato Design Studio is a company that specializes in designing and design executions,
                     namely Design Layout, Photography, Stickers and Prints. We started out as a group of developers 
                     and designers assisted a company to create itself a brand. With that concept we establish our 
                     own startup company Redtomato Design Studio aiming to spice up every ideas.
                    </p>
                </div> */}
                {/* <h2 className="about-header">Team</h2>
                <div className="page-content">
                    <p>Redtomato Design Studio, was founded by Franz Villamin
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
                    Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
                    when an unknown printer took a galley of type and scrambled it to make a type 
                    specimen book. It has survived not only five centuries, but also the leap into 
                    electronic typesetting, remaining essentially unchanged. It was popularised in 
                    the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, 
                    and more recently with desktop publishing software like Aldus PageMaker including 
                    versions of Lorem Ipsum.
                    </p>
                </div> */}
                {/* <div className='client-list'>
                    <h1>Clients</h1>
                    <ul>
                        <li>Bayong Bags</li>
                        <li>Radiant Skin</li>
                        <li>Racheen A Paris</li>
                        <li>Eats in the West</li>
                        <li>Mashiso</li>
                        <li>MCK Flowers</li>
                        <li>Thai Chix</li>
                        <li>Philippine Web Designers Organization</li>
                        <li>Hestia</li>
                        <li>Enovacore</li>
                        <li>Oil My Goodness</li>
                        <li>Viewpoint Security Systems</li>
                        <li>Coder's Development Circle</li>
                        <li>Moda Rosa</li>
                    </ul>
                </div> */}
            </div>
        );
    }
}

export default AboutPage;


// WEBPACK FOOTER //
// ./src/components/pages/AboutPage.js